import { NgModule } from '@angular/core';
import { WsAgGridWrapperComponent } from './wsAgGridWrapper.component';

@NgModule({
    imports: [WsAgGridWrapperComponent],
    exports: [WsAgGridWrapperComponent]
})
export class WsAgGridWrapperModule {
}
